import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../AuthContext";
const PrivateRoute = () => {
    const { isAuthenticated, isLoading } = useContext(AuthContext);
    const location = useLocation();
    const hasToken = (() => {
        try {
            return Boolean(localStorage.getItem("accessToken"));
        }
        catch {
            return false;
        }
    })();
    if (isLoading)
        return null; // или общий лоадер
    if (!isAuthenticated || !hasToken) {
        return _jsx(Navigate, { to: /^\/userlk\/[^/]+\/purchase\/?$/.test(location.pathname) ? `/userlogin?next=${encodeURIComponent(location.pathname + location.search)}` : "/userlogin", replace: true, state: { from: location } });
    }
    return _jsx(Outlet, {});
};
export default PrivateRoute;
